"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = iconSelect;

var _ArrowUp = _interopRequireDefault(require("../components/RheIcon/Common/ArrowUp"));

var _Bell = _interopRequireDefault(require("../components/RheIcon/Common/Bell"));

var _Blog = _interopRequireDefault(require("../components/RheIcon/Common/Blog"));

var _Caret = _interopRequireDefault(require("../components/RheIcon/Common/Caret"));

var _ChevronDown = _interopRequireDefault(require("../components/RheIcon/Common/ChevronDown"));

var _ChevronUp = _interopRequireDefault(require("../components/RheIcon/Common/ChevronUp"));

var _Cross = _interopRequireDefault(require("../components/RheIcon/Common/Cross"));

var _Date = _interopRequireDefault(require("../components/RheIcon/Common/Date"));

var _Discussion = _interopRequireDefault(require("../components/RheIcon/Common/Discussion"));

var _DocumentWithStar = _interopRequireDefault(require("../components/RheIcon/Common/DocumentWithStar"));

var _Download = _interopRequireDefault(require("../components/RheIcon/Common/Download"));

var _Expand = _interopRequireDefault(require("../components/RheIcon/Common/Expand"));

var _Favourite = _interopRequireDefault(require("../components/RheIcon/Common/Favourite"));

var _Folder = _interopRequireDefault(require("../components/RheIcon/Common/Folder"));

var _Hamburger = _interopRequireDefault(require("../components/RheIcon/Common/Hamburger"));

var _Hazard = _interopRequireDefault(require("../components/RheIcon/Common/Hazard"));

var _Help = _interopRequireDefault(require("../components/RheIcon/Common/Help"));

var _Label = _interopRequireDefault(require("../components/RheIcon/Common/Label"));

var _Link = _interopRequireDefault(require("../components/RheIcon/Common/Link"));

var _NewDocument = _interopRequireDefault(require("../components/RheIcon/Common/NewDocument"));

var _NotSharedFavourite = _interopRequireDefault(require("../components/RheIcon/Common/NotSharedFavourite"));

var _OnscreenMessage = _interopRequireDefault(require("../components/RheIcon/Common/OnscreenMessage"));

var _Organisation = _interopRequireDefault(require("../components/RheIcon/Common/Organisation"));

var _Payment = _interopRequireDefault(require("../components/RheIcon/Common/Payment"));

var _ReviewedDocument = _interopRequireDefault(require("../components/RheIcon/Common/ReviewedDocument"));

var _Search = _interopRequireDefault(require("../components/RheIcon/Common/Search"));

var _Settings = _interopRequireDefault(require("../components/RheIcon/Common/Settings"));

var _Success = _interopRequireDefault(require("../components/RheIcon/Common/Success"));

var _Tag = _interopRequireDefault(require("../components/RheIcon/Common/Tag"));

var _ThumbDown = _interopRequireDefault(require("../components/RheIcon/Common/ThumbDown"));

var _ThumbUp = _interopRequireDefault(require("../components/RheIcon/Common/ThumbUp"));

var _Tick = _interopRequireDefault(require("../components/RheIcon/Common/Tick"));

var _Time = _interopRequireDefault(require("../components/RheIcon/Common/Time"));

var _Unlock = _interopRequireDefault(require("../components/RheIcon/Common/Unlock"));

var _UpdatedDocument = _interopRequireDefault(require("../components/RheIcon/Common/UpdatedDocument"));

var _Upload = _interopRequireDefault(require("../components/RheIcon/Common/Upload"));

var _User = _interopRequireDefault(require("../components/RheIcon/Common/User"));

var _AddUser = _interopRequireDefault(require("../components/RheIcon/Common/AddUser"));

var _Support = _interopRequireDefault(require("../components/RheIcon/Common/Support"));

var _Trash = _interopRequireDefault(require("../components/RheIcon/Common/Trash"));

var _Quote = _interopRequireDefault(require("../components/RheIcon/Common/Quote"));

var _AddDocument = _interopRequireDefault(require("../components/RheIcon/Common/AddDocument"));

var _AddFolder = _interopRequireDefault(require("../components/RheIcon/Common/AddFolder"));

var _Reply = _interopRequireDefault(require("../components/RheIcon/Common/Reply"));

var _RheLogo = _interopRequireDefault(require("../components/RheIcon/Common/RheLogo"));

var _Plus = _interopRequireDefault(require("../components/RheIcon/Common/Plus"));

var _Minus = _interopRequireDefault(require("../components/RheIcon/Common/Minus"));

var _PhoneCall = _interopRequireDefault(require("../components/RheIcon/Common/PhoneCall"));

var _PhoneCallSquare = _interopRequireDefault(require("../components/RheIcon/Common/PhoneCallSquare"));

var _Case = _interopRequireDefault(require("../components/RheIcon/Common/Case"));

var _PhotoGallery = _interopRequireDefault(require("../components/RheIcon/Common/PhotoGallery"));

var _DocumentScan = _interopRequireDefault(require("../components/RheIcon/Common/DocumentScan"));

var _Film = _interopRequireDefault(require("../components/RheIcon/Common/Film"));

var _Detail = _interopRequireDefault(require("../components/RheIcon/HousingApp/Detail"));

var _Element = _interopRequireDefault(require("../components/RheIcon/HousingApp/Element"));

var _Guide = _interopRequireDefault(require("../components/RheIcon/HousingApp/Guide"));

var _Property = _interopRequireDefault(require("../components/RheIcon/HousingApp/Property"));

var _Accept = _interopRequireDefault(require("../components/RheIcon/NoiseApp/Accept"));

var _AlarmBurglar = _interopRequireDefault(require("../components/RheIcon/NoiseApp/AlarmBurglar"));

var _AlarmCar = _interopRequireDefault(require("../components/RheIcon/NoiseApp/AlarmCar"));

var _AntiSocial = _interopRequireDefault(require("../components/RheIcon/NoiseApp/AntiSocial"));

var _BallGames = _interopRequireDefault(require("../components/RheIcon/NoiseApp/BallGames"));

var _Bathroom = _interopRequireDefault(require("../components/RheIcon/NoiseApp/Bathroom"));

var _Bedroom = _interopRequireDefault(require("../components/RheIcon/NoiseApp/Bedroom"));

var _Complaint = _interopRequireDefault(require("../components/RheIcon/NoiseApp/Complaint"));

var _Construction = _interopRequireDefault(require("../components/RheIcon/NoiseApp/Construction"));

var _Diningroom = _interopRequireDefault(require("../components/RheIcon/NoiseApp/Diningroom"));

var _DIY = _interopRequireDefault(require("../components/RheIcon/NoiseApp/DIY"));

var _Dog = _interopRequireDefault(require("../components/RheIcon/NoiseApp/Dog"));

var _Drinking = _interopRequireDefault(require("../components/RheIcon/NoiseApp/Drinking"));

var _Garden = _interopRequireDefault(require("../components/RheIcon/NoiseApp/Garden"));

var _Hallway = _interopRequireDefault(require("../components/RheIcon/NoiseApp/Hallway"));

var _Kitchen = _interopRequireDefault(require("../components/RheIcon/NoiseApp/Kitchen"));

var _Livingroom = _interopRequireDefault(require("../components/RheIcon/NoiseApp/Livingroom"));

var _MachineryDomestic = _interopRequireDefault(require("../components/RheIcon/NoiseApp/MachineryDomestic"));

var _MachineryIndustrial = _interopRequireDefault(require("../components/RheIcon/NoiseApp/MachineryIndustrial"));

var _Music = _interopRequireDefault(require("../components/RheIcon/NoiseApp/Music"));

var _MusicLive = _interopRequireDefault(require("../components/RheIcon/NoiseApp/MusicLive"));

var _MusicRecorded = _interopRequireDefault(require("../components/RheIcon/NoiseApp/MusicRecorded"));

var _Other = _interopRequireDefault(require("../components/RheIcon/NoiseApp/Other"));

var _OtherSquare = _interopRequireDefault(require("../components/RheIcon/NoiseApp/OtherSquare"));

var _Party = _interopRequireDefault(require("../components/RheIcon/NoiseApp/Party"));

var _Pause = _interopRequireDefault(require("../components/RheIcon/NoiseApp/Pause"));

var _Play = _interopRequireDefault(require("../components/RheIcon/NoiseApp/Play"));

var _PublicSpace = _interopRequireDefault(require("../components/RheIcon/NoiseApp/PublicSpace"));

var _Recording = _interopRequireDefault(require("../components/RheIcon/NoiseApp/Recording"));

var _Reject = _interopRequireDefault(require("../components/RheIcon/NoiseApp/Reject"));

var _Voices = _interopRequireDefault(require("../components/RheIcon/NoiseApp/Voices"));

var _Workplace = _interopRequireDefault(require("../components/RheIcon/NoiseApp/Workplace"));

var _Animals = _interopRequireDefault(require("../components/RheIcon/PortHealth/Animals"));

var _Communication = _interopRequireDefault(require("../components/RheIcon/PortHealth/Communication"));

var _Consignment = _interopRequireDefault(require("../components/RheIcon/PortHealth/Consignment"));

var _Fish = _interopRequireDefault(require("../components/RheIcon/PortHealth/Fish"));

var _Flight = _interopRequireDefault(require("../components/RheIcon/PortHealth/Flight"));

var _LssDeclaration = _interopRequireDefault(require("../components/RheIcon/PortHealth/LssDeclaration"));

var _LssDipsLevel = _interopRequireDefault(require("../components/RheIcon/PortHealth/LssDipsLevel1"));

var _LssDipsLevel2 = _interopRequireDefault(require("../components/RheIcon/PortHealth/LssDipsLevel2"));

var _LssDipsLevel3 = _interopRequireDefault(require("../components/RheIcon/PortHealth/LssDipsLevel3"));

var _LssDipsLevel4 = _interopRequireDefault(require("../components/RheIcon/PortHealth/LssDipsLevel4"));

var _LssImporterRisk = _interopRequireDefault(require("../components/RheIcon/PortHealth/LssImporterRisk"));

var _LssProductRisk = _interopRequireDefault(require("../components/RheIcon/PortHealth/LssProductRisk"));

var _Organic = _interopRequireDefault(require("../components/RheIcon/PortHealth/Organic"));

var _OtherProduce = _interopRequireDefault(require("../components/RheIcon/PortHealth/OtherProduce"));

var _SpecialTradeAgreement = _interopRequireDefault(require("../components/RheIcon/PortHealth/SpecialTradeAgreement"));

var _Vegetables = _interopRequireDefault(require("../components/RheIcon/PortHealth/Vegetables"));

var _AbuseViolence = _interopRequireDefault(require("../components/RheIcon/Reportable/AbuseViolence"));

var _AnimalCruelty = _interopRequireDefault(require("../components/RheIcon/Reportable/AnimalCruelty"));

var _AnimalNuisance = _interopRequireDefault(require("../components/RheIcon/Reportable/AnimalNuisance"));

var _Bonfire = _interopRequireDefault(require("../components/RheIcon/Reportable/Bonfire"));

var _BusinessUseOfProperty = _interopRequireDefault(require("../components/RheIcon/Reportable/BusinessUseOfProperty"));

var _Busking = _interopRequireDefault(require("../components/RheIcon/Reportable/Busking"));

var _CommunalAreas = _interopRequireDefault(require("../components/RheIcon/Reportable/CommunalAreas"));

var _CrackHouse = _interopRequireDefault(require("../components/RheIcon/Reportable/CrackHouse"));

var _Customise = _interopRequireDefault(require("../components/RheIcon/Reportable/Customise"));

var _Damage = _interopRequireDefault(require("../components/RheIcon/Reportable/Damage"));

var _DogFouling = _interopRequireDefault(require("../components/RheIcon/Reportable/DogFouling"));

var _DomesticViolence = _interopRequireDefault(require("../components/RheIcon/Reportable/DomesticViolence"));

var _DrugDealing = _interopRequireDefault(require("../components/RheIcon/Reportable/DrugDealing"));

var _EnvironmentalCrime = _interopRequireDefault(require("../components/RheIcon/Reportable/EnvironmentalCrime"));

var _FlyPosting = _interopRequireDefault(require("../components/RheIcon/Reportable/FlyPosting"));

var _FlyTipping = _interopRequireDefault(require("../components/RheIcon/Reportable/FlyTipping"));

var _GangNuisance = _interopRequireDefault(require("../components/RheIcon/Reportable/GangNuisance"));

var _GardenCondition = _interopRequireDefault(require("../components/RheIcon/Reportable/GardenCondition"));

var _Graffiti = _interopRequireDefault(require("../components/RheIcon/Reportable/Graffiti"));

var _HateCrime = _interopRequireDefault(require("../components/RheIcon/Reportable/HateCrime"));

var _Litter = _interopRequireDefault(require("../components/RheIcon/Reportable/Litter"));

var _Others = _interopRequireDefault(require("../components/RheIcon/Reportable/Others"));

var _PavementObstruction = _interopRequireDefault(require("../components/RheIcon/Reportable/PavementObstruction"));

var _Potholes = _interopRequireDefault(require("../components/RheIcon/Reportable/Potholes"));

var _RefuseCollection = _interopRequireDefault(require("../components/RheIcon/Reportable/RefuseCollection"));

var _RefuseCommercial = _interopRequireDefault(require("../components/RheIcon/Reportable/RefuseCommercial"));

var _RefuseDomestic = _interopRequireDefault(require("../components/RheIcon/Reportable/RefuseDomestic"));

var _Repairs = _interopRequireDefault(require("../components/RheIcon/Reportable/Repairs"));

var _RoadWorks = _interopRequireDefault(require("../components/RheIcon/Reportable/RoadWorks"));

var _SubstanceAbuse = _interopRequireDefault(require("../components/RheIcon/Reportable/SubstanceAbuse"));

var _TreeBranch = _interopRequireDefault(require("../components/RheIcon/Reportable/TreeBranch"));

var _UnauthorisedAlterations = _interopRequireDefault(require("../components/RheIcon/Reportable/UnauthorisedAlterations"));

var _Vehicle = _interopRequireDefault(require("../components/RheIcon/Reportable/Vehicle"));

var _VehicleAbandoned = _interopRequireDefault(require("../components/RheIcon/Reportable/VehicleAbandoned"));

var _VehicleEncampent = _interopRequireDefault(require("../components/RheIcon/Reportable/VehicleEncampent"));

var _VehicleNoise = _interopRequireDefault(require("../components/RheIcon/Reportable/VehicleNoise"));

var _VehicleParking = _interopRequireDefault(require("../components/RheIcon/Reportable/VehicleParking"));

var _YouthNuisance = _interopRequireDefault(require("../components/RheIcon/Reportable/YouthNuisance"));

var _Connected = _interopRequireDefault(require("../components/RheIcon/RIAMS/Connected"));

var _Decision = _interopRequireDefault(require("../components/RheIcon/RIAMS/Decision"));

var _Library = _interopRequireDefault(require("../components/RheIcon/RIAMS/Library"));

var _Lock = _interopRequireDefault(require("../components/RheIcon/RIAMS/Lock"));

var _Edit = _interopRequireDefault(require("../components/RheIcon/Whitedocs/Edit"));

var _Form = _interopRequireDefault(require("../components/RheIcon/Whitedocs/Form"));

var _Location = _interopRequireDefault(require("../components/RheIcon/Whitedocs/Location"));

var _Schedule = _interopRequireDefault(require("../components/RheIcon/Whitedocs/Schedule"));

var _Share = _interopRequireDefault(require("../components/RheIcon/Whitedocs/Share"));

var _Task = _interopRequireDefault(require("../components/RheIcon/Whitedocs/Task"));

var _Team = _interopRequireDefault(require("../components/RheIcon/Whitedocs/Team"));

var _SharedFavourite = _interopRequireDefault(require("../components/RheIcon/Common/SharedFavourite"));

var _Status = _interopRequireDefault(require("../components/RheIcon/Common/Status"));

var _ArrowDown = _interopRequireDefault(require("../components/RheIcon/Linear/ArrowDown"));

var _ArrowLeft = _interopRequireDefault(require("../components/RheIcon/Linear/ArrowLeft"));

var _ArrowRight = _interopRequireDefault(require("../components/RheIcon/Linear/ArrowRight"));

var _ArrowUp2 = _interopRequireDefault(require("../components/RheIcon/Linear/ArrowUp"));

var _Asterisk = _interopRequireDefault(require("../components/RheIcon/Linear/Asterisk"));

var _Camera = _interopRequireDefault(require("../components/RheIcon/Linear/Camera"));

var _ChevronDown2 = _interopRequireDefault(require("../components/RheIcon/Linear/ChevronDown"));

var _ChevronLeft = _interopRequireDefault(require("../components/RheIcon/Linear/ChevronLeft"));

var _ChevronLeftDouble = _interopRequireDefault(require("../components/RheIcon/Linear/ChevronLeftDouble"));

var _ChevronRight = _interopRequireDefault(require("../components/RheIcon/Linear/ChevronRight"));

var _ChevronRightDouble = _interopRequireDefault(require("../components/RheIcon/Linear/ChevronRightDouble"));

var _ChevronUp2 = _interopRequireDefault(require("../components/RheIcon/Linear/ChevronUp"));

var _Cross2 = _interopRequireDefault(require("../components/RheIcon/Linear/Cross"));

var _Download2 = _interopRequireDefault(require("../components/RheIcon/Linear/Download"));

var _Exclamation = _interopRequireDefault(require("../components/RheIcon/Linear/Exclamation"));

var _Expand2 = _interopRequireDefault(require("../components/RheIcon/Linear/Expand"));

var _EyeClosed = _interopRequireDefault(require("../components/RheIcon/Linear/EyeClosed"));

var _EyeOpen = _interopRequireDefault(require("../components/RheIcon/Linear/EyeOpen"));

var _Hamburger2 = _interopRequireDefault(require("../components/RheIcon/Linear/Hamburger"));

var _Information = _interopRequireDefault(require("../components/RheIcon/Linear/Information"));

var _Like = _interopRequireDefault(require("../components/RheIcon/Linear/Like"));

var _Link2 = _interopRequireDefault(require("../components/RheIcon/Linear/Link"));

var _LockClosed = _interopRequireDefault(require("../components/RheIcon/Linear/LockClosed"));

var _LockOpen = _interopRequireDefault(require("../components/RheIcon/Linear/LockOpen"));

var _Mail = _interopRequireDefault(require("../components/RheIcon/Linear/Mail"));

var _Minus2 = _interopRequireDefault(require("../components/RheIcon/Linear/Minus"));

var _Notification = _interopRequireDefault(require("../components/RheIcon/Linear/Notification"));

var _Paperclip = _interopRequireDefault(require("../components/RheIcon/Linear/Paperclip"));

var _Plus2 = _interopRequireDefault(require("../components/RheIcon/Linear/Plus"));

var _Preferences = _interopRequireDefault(require("../components/RheIcon/Linear/Preferences"));

var _Question = _interopRequireDefault(require("../components/RheIcon/Linear/Question"));

var _Reply2 = _interopRequireDefault(require("../components/RheIcon/Linear/Reply"));

var _Search2 = _interopRequireDefault(require("../components/RheIcon/Linear/Search"));

var _Tick2 = _interopRequireDefault(require("../components/RheIcon/Linear/Tick"));

var _Upload2 = _interopRequireDefault(require("../components/RheIcon/Linear/Upload"));

var _WasteBasket = _interopRequireDefault(require("../components/RheIcon/Linear/WasteBasket"));

var _Edit2 = _interopRequireDefault(require("../components/RheIcon/Linear/Edit"));

var _SignOut = _interopRequireDefault(require("../components/RheIcon/Linear/SignOut"));

var _KebabMenu = _interopRequireDefault(require("../components/RheIcon/Linear/KebabMenu"));

var _Note = _interopRequireDefault(require("../components/RheIcon/Linear/Note"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Common
// Housing App
// Noise App
// PortHealth
// import Airplane from '../components/RheIcon/PortHealth/Airplane';
// Reportable
// RIAMS
// Whitedocs
// Linear
function iconSelect(icon) {
  icon = icon.toLowerCase();

  switch (icon) {
    case "arrow up":
      return _ArrowUp.default;

    case "bell":
      return _Bell.default;

    case "blog":
      return _Blog.default;

    case "cross":
      return _Cross.default;

    case "decision":
      return _Decision.default;

    case "discussion":
      return _Discussion.default;

    case "new document":
      return _NewDocument.default;

    case "updated document":
      return _UpdatedDocument.default;

    case "favourite document":
      return _DocumentWithStar.default;

    case "document with star":
      return _DocumentWithStar.default;

    case "exclamation":
      return _LssImporterRisk.default;

    case "reviewed document":
      return _ReviewedDocument.default;

    case "folder":
      return _Folder.default;

    case "hamburger":
      return _Hamburger.default;

    case "link":
      return _Link.default;

    case "message":
      return _Discussion.default;

    case "search":
      return _Search.default;

    case "search-2":
      return _Search.default;

    case "consignment":
      return _Consignment.default;

    case "airplane":
      return _Flight.default;

    case "settings":
      return _Settings.default;

    case "shared":
      return _Share.default;

    case "share":
      return _Share.default;

    case "not shared":
      return _Share.default;

    case "suite":
      return _RheLogo.default;

    case "support":
      return _Support.default;

    case "tag":
      return _Tag.default;

    case "tick":
      return _Tick.default;

    case "trash":
      return _Trash.default;

    case "user":
      return _User.default;

    case "add user":
      return _AddUser.default;

    case "not favourite":
      return _Favourite.default;

    case "favourite":
      return _Favourite.default;

    case "download":
      return _Download.default;

    case "download disabled":
      return _Download.default;

    case "feedback":
      return _Blog.default;

    case "more coloured":
      return _Animals.default;
    //     return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/1928_RIAMS_icon_more-coloured.png";

    case "more":
      return _Animals.default;
    //     return "https://dsbe97xjoc0t4.cloudfront.net/images/icons/1928_RIAMS_icon_more.png";

    case "not connected":
      return _Connected.default;

    case "connected":
      return _Connected.default;

    case "shared favourite":
      return _SharedFavourite.default;

    case "not shared favourite":
      return _NotSharedFavourite.default;

    case "expand":
      return _Expand.default;

    case "upload":
      return _Upload.default;

    case "lss dips level 1":
      return _LssDipsLevel.default;

    case "lss dips level 2":
      return _LssDipsLevel2.default;

    case "lss dips level 3":
      return _LssDipsLevel3.default;

    case "lss dips level 4":
      return _LssDipsLevel4.default;

    case "lss checking":
      return _Search.default;

    case "lss consignments":
      return _Consignment.default;

    case "lss declaration":
      return _LssDeclaration.default;

    case "flight":
      return _Flight.default;

    case "organic":
      return _Organic.default;

    case "payment":
      return _Payment.default;

    case "animals":
      return _Animals.default;

    case "fish":
      return _Fish.default;

    case "other":
      return _Other.default;

    case "vegetables":
      return _Vegetables.default;

    case "lss importer risk":
      return _LssImporterRisk.default;

    case "lss product risk":
      return _LssProductRisk.default;

    case "communication":
      return _Communication.default;

    case "hazard":
      return _Hazard.default;

    case "on screen message":
      return _OnscreenMessage.default;

    case "organisation":
      return _Organisation.default;

    case "search-3":
      return _Search.default;

    case "special trade agreement":
      return _SpecialTradeAgreement.default;

    case "status":
      return _Status.default;

    case "chevron up":
      return _ChevronUp.default;

    case "chevron down":
      return _ChevronDown.default;

    case "date":
      return _Date.default;

    case "help":
      return _Help.default;

    case "label":
      return _Label.default;

    case "success":
      return _Success.default;

    case "thumb down":
      return _ThumbDown.default;

    case "thumb up":
      return _ThumbUp.default;

    case "time":
      return _Time.default;

    case "unlock":
      return _Unlock.default;

    case "detail":
      return _Detail.default;

    case "element":
      return _Element.default;

    case "guide":
      return _Guide.default;

    case "property":
      return _Property.default;

    case "accept":
      return _Accept.default;

    case "alarm burglar":
      return _AlarmBurglar.default;

    case "alarm car":
      return _AlarmCar.default;

    case "anti social":
      return _AntiSocial.default;

    case "ball games":
      return _BallGames.default;

    case "bathroom":
      return _Bathroom.default;

    case "bedroom":
      return _Bedroom.default;

    case "complaint":
      return _Complaint.default;

    case "construction":
      return _Construction.default;

    case "dining room":
      return _Diningroom.default;

    case "diy":
      return _DIY.default;

    case "dog":
      return _Dog.default;

    case "drinking":
      return _Drinking.default;

    case "garden":
      return _Garden.default;

    case "hallway":
      return _Hallway.default;

    case "kitchen":
      return _Kitchen.default;

    case "living room":
      return _Livingroom.default;

    case "machinery domestic":
      return _MachineryDomestic.default;

    case "machinery industrial":
      return _MachineryIndustrial.default;

    case "music":
      return _Music.default;

    case "music live":
      return _MusicLive.default;

    case "music recorded":
      return _MusicRecorded.default;

    case "other square":
      return _OtherSquare.default;

    case "party":
      return _Party.default;

    case "pause":
      return _Pause.default;

    case "play":
      return _Play.default;

    case "public space":
      return _PublicSpace.default;

    case "reject":
      return _Reject.default;

    case "voices":
      return _Voices.default;

    case "workplace":
      return _Workplace.default;

    case "plus":
      return _Plus.default;

    case "minus":
      return _Minus.default;

    case "other produce":
      return _OtherProduce.default;

    case "abusive violence":
      return _AbuseViolence.default;

    case "animal cruelty":
      return _AnimalCruelty.default;

    case "animal nuisance":
      return _AnimalNuisance.default;

    case "bonfire":
      return _Bonfire.default;

    case "business use of property":
      return _BusinessUseOfProperty.default;

    case "busking":
      return _Busking.default;

    case "communal areas":
      return _CommunalAreas.default;

    case "crack house":
      return _CrackHouse.default;

    case "customise":
      return _Customise.default;

    case "damage":
      return _Damage.default;

    case "dog fouling":
      return _DogFouling.default;

    case "domestic violence":
      return _DomesticViolence.default;

    case "drug dealing":
      return _DrugDealing.default;

    case "environmental crime":
      return _EnvironmentalCrime.default;

    case "fly posting":
      return _FlyPosting.default;

    case "fly tipping":
      return _FlyTipping.default;

    case "gang nuisance":
      return _GangNuisance.default;

    case "garden condition":
      return _GardenCondition.default;

    case "graffiti":
      return _Graffiti.default;

    case "hate crime":
      return _HateCrime.default;

    case "litter":
      return _Litter.default;

    case "others":
      return _Others.default;

    case "pavement obstruction":
      return _PavementObstruction.default;

    case "potholes":
      return _Potholes.default;

    case "refuse collection":
      return _RefuseCollection.default;

    case "refuse commercial":
      return _RefuseCommercial.default;

    case "refuse domestic":
      return _RefuseDomestic.default;

    case "repairs":
      return _Repairs.default;

    case "roadworks":
      return _RoadWorks.default;

    case "substance abuse":
      return _SubstanceAbuse.default;

    case "tree branch":
      return _TreeBranch.default;

    case "unauthorised alterations":
      return _UnauthorisedAlterations.default;

    case "vehicle":
      return _Vehicle.default;

    case "vehicle abandoned":
      return _VehicleAbandoned.default;

    case "vehicle encampment":
      return _VehicleEncampent.default;

    case "vehicle noise":
      return _VehicleNoise.default;

    case "vehicle parking":
      return _VehicleParking.default;

    case "youth nuisance":
      return _YouthNuisance.default;

    case "library":
      return _Library.default;

    case "lock":
      return _Lock.default;

    case "edit":
      return _Edit.default;

    case "form":
      return _Form.default;

    case "location":
      return _Location.default;

    case "schedule":
      return _Schedule.default;

    case "task":
      return _Task.default;

    case "team":
      return _Team.default;

    case "quote":
      return _Quote.default;

    case 'add document':
      return _AddDocument.default;

    case 'add folder':
      return _AddFolder.default;

    case 'reply':
      return _Reply.default;

    case 'phone call':
      return _PhoneCall.default;

    case 'phone call square':
      return _PhoneCallSquare.default;

    case 'case':
      return _Case.default;

    case 'linear arrow down':
      return _ArrowDown.default;

    case 'linear arrow left':
      return _ArrowLeft.default;

    case 'linear arrow right':
      return _ArrowRight.default;

    case 'linear arrow up':
      return _ArrowUp2.default;

    case 'linear asterisk':
      return _Asterisk.default;

    case 'linear camera':
      return _Camera.default;

    case 'linear chevron down':
      return _ChevronDown2.default;

    case 'linear chevron left':
      return _ChevronLeft.default;

    case 'linear chevron left double':
      return _ChevronLeftDouble.default;

    case 'linear chevron right':
      return _ChevronRight.default;

    case 'linear chevron right double':
      return _ChevronRightDouble.default;

    case 'linear chevron up':
      return _ChevronUp2.default;

    case 'linear cross':
      return _Cross2.default;

    case 'linear download':
      return _Download2.default;

    case 'linear exclamation':
      return _Exclamation.default;

    case 'linear expand':
      return _Expand2.default;

    case 'linear eye closed':
      return _EyeClosed.default;

    case 'linear eye open':
      return _EyeOpen.default;

    case 'linear hamburger':
      return _Hamburger2.default;

    case 'linear information':
      return _Information.default;

    case 'linear like':
      return _Like.default;

    case 'linear link':
      return _Link2.default;

    case 'linear lock closed':
      return _LockClosed.default;

    case 'linear lock open':
      return _LockOpen.default;

    case 'linear mail':
      return _Mail.default;

    case 'linear minus':
      return _Minus2.default;

    case 'linear notification':
      return _Notification.default;

    case 'linear paperclip':
      return _Paperclip.default;

    case 'linear plus':
      return _Plus2.default;

    case 'linear preferences':
      return _Preferences.default;

    case 'linear question':
      return _Question.default;

    case 'linear reply':
      return _Reply2.default;

    case 'linear search':
      return _Search2.default;

    case 'linear tick':
      return _Tick2.default;

    case 'linear upload':
      return _Upload2.default;

    case 'linear wastebasket':
      return _WasteBasket.default;

    case 'linear edit':
      return _Edit2.default;

    case 'linear kebab menu':
      return _KebabMenu.default;

    case 'sign out':
      return _SignOut.default;

    case 'photo gallery':
      return _PhotoGallery.default;

    case 'document scan':
      return _DocumentScan.default;

    case 'linear note':
      return _Note.default;

    case 'recording':
      return _Recording.default;

    case 'caret':
      return _Caret.default;

    case 'film':
      return _Film.default;

    default:
      console.log('If you are seeing this and everything is breaking then you probably did not enter the correct icon name in the icon prop.');
      break;
  }
}